import React from "react";

import CreditCardInput from "@CheckoutOnepageOffers/components/atoms/CreditCardInput";
import Input, {
  WrapperInputs,
} from "@CheckoutOnepageOffers/components/atoms/Input";
import InputMask from "@CheckoutOnepageOffers/components/atoms/InputMask";
import Select from "@CheckoutOnepageOffers/components/atoms/Select";
import AddressForm from "@CheckoutOnepageOffers/components/templates/AddressForm";
import { useCheckoutOnepageOffersContext } from "@CheckoutOnepageOffers/provider/useCheckoutOnepageOffersContext";
import { useCheckoutContext } from "@payment/providers/CheckoutProvider/useCheckoutContext";
import { getInstallmentsCheckoutOnePage } from "@payment/utils/getInstallment";
import { Scope } from "@unform/core";

import {
  CreditCardFields,
  CreditCardFormContainer,
  Title,
  WrapperCreditCardInputs,
} from "./styles";

const CreditCardForm = () => {
  const { checkoutOnePageDispatch, offer, installments } =
    useCheckoutOnepageOffersContext();

  const { country } = useCheckoutContext();

  const selectInstallment = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.currentTarget.value;

    checkoutOnePageDispatch({
      type: "SET_CHECKOUT_ONE_PAGE_SETTINGS",
      payload: {
        installmentSelected: value,
      },
    });
  };

  const installmentsOptions = getInstallmentsCheckoutOnePage(installments);

  const onlyNumbers = /[^0-9]/g;

  const defaultValueSelectInstallment = Number(offer?.offer?.max_installments);

  return (
    <CreditCardFormContainer>
      <CreditCardFields className="credit-card-form-container">
        <Title>Dados do cartão de crédito</Title>

        <Scope path="credit_card">
          <WrapperInputs>
            <Input
              toUpperCase
              name="card_holder_name"
              label="Nome impresso no cartão"
              placeholder="Digite o nome no cartão"
              required
            />
          </WrapperInputs>

          <WrapperCreditCardInputs>
            <CreditCardInput
              required
              type="text"
              name="card_number"
              label="Número do cartão"
              placeholder="Digite o número do cartão"
            />

            <InputMask
              required
              mask="99/99"
              placeholder="MM/AA"
              name="card_expiration_date"
              className="expiration_date"
            />

            <Input
              required
              name="card_cvv"
              maxLength={4}
              className="cvv"
              placeholder="CVV"
              replace={onlyNumbers}
              inputMode="numeric"
            />
          </WrapperCreditCardInputs>

          {installmentsOptions?.length > 1 && country === "Brasil" && (
            <WrapperInputs>
              <Select
                required
                name="installments"
                label="Número de parcelas"
                onChange={selectInstallment}
                options={installmentsOptions}
                defaultValue={defaultValueSelectInstallment}
              />
            </WrapperInputs>
          )}
        </Scope>
      </CreditCardFields>

      {offer?.offer?.details?.ask_for_address === 1 && country === "Brasil" && (
        <AddressForm title="Endereço do proprietário do cartão" />
      )}
    </CreditCardFormContainer>
  );
};

export default CreditCardForm;
